<template>
    <div v-if="open" @click="closePopup" class="fixed z-[90] top-0 bottom-0 left-0 right-0 backdrop-blur-md backdrop-brightness-75 flex flex-col justify-center items-center">
        <div
            @click.stop
            class="relative mx-auto bg-white rounded-md shadow-md max-w-[1000px] min-h-[100px] max-h-[70vh] overflow-y-auto"
            :class="[popupWidth || 'w-10/12 md:w-3/4 lg:w-7/12', padding ? 'p-8' : '', type === 'text' ? 'p-10' : '']"
        >
            <!-- Close Icon -->
            <button
                v-if="!hideClose"
                @click="closePopup"
                aria-label="close popup"
                class="absolute top-4 right-4 w-10 h-10 bg-white rounded-full shadow-md flex items-center justify-center z-10 text-blue-dark hover:bg-gray-100 transition"
            >
                <Icon type="Close" viewBox="0 0 26 26" width="22" height="22" class="shrink-0" />
            </button>

            <!-- Popup Content -->
            <slot />
        </div>
    </div>
</template>

<script setup>
import { watch, onBeforeUnmount } from 'vue';

const props = defineProps({
    open: Boolean,
    popupWidth: String,
    padding: Boolean,
    hideClose: Boolean,
    type: {
        type: String,
        default: 'default'
    }
});

const emit = defineEmits(['open']);

const closePopup = () => {
    emit('open', false);
};

const lockScroll = () => {
    document.body.style.overflow = 'hidden';
};

const unlockScroll = () => {
    document.body.style.overflow = '';
};

watch(
    () => props.open,
    (newVal) => {
        if (newVal) lockScroll();
        else unlockScroll();
    },
    { immediate: true }
);

onBeforeUnmount(() => {
    unlockScroll();
});
</script>
